import axios from 'axios';
import { API_BASE_URL } from '../utils/constants';
import { getAuthToken } from '../utils/storage';
import { extractApiError } from '../utils/apiError';
import { applyWarehouseFilter, warehouseParamsSerializer } from '../utils/warehouseParams';

const salesAnalyticsAPI = axios.create({
    baseURL: `${API_BASE_URL}/api/v1/sales-analytics`,
    headers: { 'Content-Type': 'application/json' },
    paramsSerializer: warehouseParamsSerializer,
});

salesAnalyticsAPI.interceptors.request.use(
    (config) => {
        const token = getAuthToken();
        if (token) config.headers.Authorization = `Bearer ${token}`;
        return applyWarehouseFilter(config);
    },
    (error) => Promise.reject(error)
);

const salesAnalyticsService = {
    async getSummary(params = {}) {
        try {
            const response = await salesAnalyticsAPI.get('/summary', { params });
            return { success: true, data: response.data };
        } catch (error) {
            return { success: false, error: extractApiError(error) };
        }
    },

    async getOrders(params = {}, options = {}) {
        try {
            const response = await salesAnalyticsAPI.get('/orders', { params, ...options });
            return { success: true, data: response.data };
        } catch (error) {
            if (axios.isCancel(error)) {
                return { success: false, error: 'Request canceled', isCanceled: true };
            }
            return { success: false, error: extractApiError(error) };
        }
    },

    async getDaily(params = {}, options = {}) {
        try {
            const response = await salesAnalyticsAPI.get('/daily', { params, ...options });
            return { success: true, data: response.data };
        } catch (error) {
            if (axios.isCancel(error)) {
                return { success: false, error: 'Request canceled', isCanceled: true };
            }
            return { success: false, error: extractApiError(error) };
        }
    },

    async getLeaderboard(params = {}, options = {}) {
        try {
            const response = await salesAnalyticsAPI.get('/leaderboard', { params, ...options });
            return { success: true, data: response.data };
        } catch (error) {
            if (axios.isCancel(error)) {
                return { success: false, error: 'Request canceled', isCanceled: true };
            }
            return { success: false, error: extractApiError(error) };
        }
    },
};

export default salesAnalyticsService;
